import { render, staticRenderFns } from "./ExchangeCousePopup.vue?vue&type=template&id=2d8996e7&scoped=true"
import script from "./ExchangeCousePopup.vue?vue&type=script&lang=ts"
export * from "./ExchangeCousePopup.vue?vue&type=script&lang=ts"
import style0 from "./ExchangeCousePopup.vue?vue&type=style&index=0&id=2d8996e7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8996e7",
  null
  
)

export default component.exports